import {
  Box,
  Table,
  Tag,
  Text,
  VStack,
} from "@chakra-ui/react";
import { formatNumber, formatPercent } from "../../../../store/helpers";

const AgentServicesTableRows = ({ data, totalServiceData }) => {
  return (
    <>
      {data.map((agentData, index) => {
        const { total } = agentData;
        let totalPct = (total / totalServiceData) * 100 || 0;
        return (
          <Table.Row key={`${agentData.agentName}-${index}`}>
            <Table.Cell>{index + 1}</Table.Cell>
            <Table.Cell>{agentData.agentName}</Table.Cell>
            <Table.Cell borderRight="1px solid #dadce0">
              <VStack gap="2px" align="start">
                <Text color={"var(--green)"}>
                  {formatNumber(agentData.total)}
                </Text>
                <Text
                  color="gray.500"
                  fontWeight="semibold"
                  fontSize="xs"
                  textTransform="uppercase"
                >
                  ({formatPercent(totalPct)})
                </Text>
              </VStack>
            </Table.Cell>
            <Table.Cell borderRight="1px solid #dadce0">
              {formatNumber(agentData.average)}
            </Table.Cell>
            <Table.Cell>{formatNumber(agentData.min)}</Table.Cell>
            <Table.Cell>{formatNumber(agentData.max)}</Table.Cell>
            <Table.Cell>
              <VStack gap="2px" align="start">
                <Text color={"var(--green)"}>
                  {formatNumber(agentData.numCompleted)}
                </Text>
                <Text
                  color="gray.500"
                  fontWeight="semibold"
                  fontSize="xs"
                  textTransform="uppercase"
                >
                  ({formatPercent(agentData.pctCompleted)})
                </Text>
              </VStack>
            </Table.Cell>

            <Table.Cell>
              <VStack gap="2px" align="start">
                <Text color={"var(--red)"}>
                  {formatNumber(agentData.numNoShow)}
                </Text>
                <Text
                  color="gray.500"
                  fontWeight="semibold"
                  fontSize="xs"
                  textTransform="uppercase"
                >
                  ({formatPercent(agentData.pctNoShow)})
                </Text>
              </VStack>
            </Table.Cell>

            <Table.Cell>
              <VStack gap="2px" align="start">
                <Text color={"var(--red)"}>
                  {formatNumber(agentData.numUnattended)}
                </Text>
                <Text
                  color="gray.500"
                  fontWeight="semibold"
                  fontSize="xs"
                  textTransform="uppercase"
                >
                  ({formatPercent(agentData.pctUnattended)})
                </Text>
              </VStack>
            </Table.Cell>
          </Table.Row>
        );
      })}
    </>
  );
};
const AgentTicketsPerServiceTable = ({
  serviceData,
  branchName,

  branchIndex,
  index,
}) => {
  const { serviceName, agentsData, totalServiceData } = serviceData;

  const title = `${branchIndex + 1}.${
    index + 1
  }. ${serviceName}`;
  

  return (
    <Box>
      <h3>{title}</h3>
      {!totalServiceData ? (
        <Text fontSize="sm">No data available for this report</Text>
      ) : (
        <></>
      )}
      <Tag.Root>
        <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
      </Tag.Root>

      {totalServiceData ? (
        <Table.Root className="stripedTable" size="sm">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>#</Table.ColumnHeader>
              <Table.ColumnHeader>Agent Name</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Average</Table.ColumnHeader>
              <Table.ColumnHeader>Min</Table.ColumnHeader>
              <Table.ColumnHeader>Max</Table.ColumnHeader>
              <Table.ColumnHeader>Completed</Table.ColumnHeader>
              <Table.ColumnHeader>No Show</Table.ColumnHeader>
              <Table.ColumnHeader>Unattended</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              <AgentServicesTableRows
                totalServiceData={totalServiceData}
                data={agentsData}
              />
            }
          </Table.Body>
        </Table.Root>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default AgentTicketsPerServiceTable;
